import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';
import Link from 'shopper/components/Link';

import placeholder from 'lib/placeholder';

const ReplyButton = ({ onClick }) => (
  <Link
    aria-label="Responder comentário"
    className="flex items-center gap-2 p-2 text-neutral-low-300 hover:text-primary-500 hover:no-underline dark:text-neutral-high-100 hover:[&>svg]:text-primary-500 hover:dark:[&>svg]:text-primary-100"
    size="size3"
    type="primary"
    onClick={onClick}
  >
    <Icon className="text-neutral-low-300" name="chat" />
    {placeholder('actions.reply')}
  </Link>
);

ReplyButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ReplyButton;
